__turbopack_context__.v({
  "radio-button": "radio-button-module-scss-module__lJuD5a__radio-button",
  "state-default": "radio-button-module-scss-module__lJuD5a__state-default",
  "state-disabled": "radio-button-module-scss-module__lJuD5a__state-disabled",
  "state-error": "radio-button-module-scss-module__lJuD5a__state-error",
});
